// BASE_ROUTE is injected by the studio preview (per-session path prefix, e.g.
// /session/s_abc123/instore) and baked in by vite.config; falls back to the
// regular /instore mount everywhere else.
export const APP_PATH = process.env.BASE_ROUTE || "/instore";

export const ROUTES = {
  WelcomeView: "/welcome",
  Registration: "/registration",
  EntryView: "/",
  PreloadView: "/preload",
  ContentView: "/content",
  ConfirmedOrderView: "/confirmed-order",
  ErrorView: "/error",
  ErrorExpiredView: "/error-expired",
  Bestseller: "/bestseller",
  ForwardBasket: "/forward-basket",
  SuccessView: "/success",
} as const;
